/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react'
import { isEmpty } from 'lodash'

import { Filters } from 'components'

import constants from 'constants/index'
import helpers from 'helpers'

const QuestionnaireFilter = ({ filter }) => {
  const [companies, setCompanies] = useState([])
  const [companyInputValue, setCompanyInputValue] = useState('')
  const [isLoadingCompaniesInput, setIsLoadingCompaniesInput] = useState(false)
  const [isLoadingCompanies, setIsLoadingCompanies] = useState(false)

  const { loadCompanies, mountCompanyParams, instructionsText } =
    helpers.companies.typeAndSearch
  const { nameWithDocumentByArrayObject } = helpers.companies.nameWithDocument
  const { filters, drawerOpen } = filter

  const handleTypeCompaniesInput = (e) => {
    setCompanyInputValue(e.target.value)
  }

  const companiesOptionsValues = nameWithDocumentByArrayObject(
    isLoadingCompaniesInput ? [] : companies,
  )

  useEffect(() => {
    const getCompanies = setTimeout(() => {
      const hasCompanyValueToFetch =
        companyInputValue.length < 3 && isEmpty(filters?.companyId)

      if (hasCompanyValueToFetch || !drawerOpen) return

      loadCompanies(
        mountCompanyParams(companyInputValue, filters),
        setIsLoadingCompaniesInput,
        setCompanies,
      )
    }, 1000)

    return () => clearTimeout(getCompanies)
  }, [companyInputValue])

  useEffect(() => {
    if (filters?.companyId) {
      loadCompanies(
        mountCompanyParams(companyInputValue, filters),
        setIsLoadingCompanies,
        setCompanies,
      )
    }
  }, [filters?.companyId])

  useEffect(() => {
    if (!drawerOpen && companyInputValue) setCompanyInputValue('')
  }, [drawerOpen])

  return (
    <Filters filter={filter} isLoading={isLoadingCompanies}>
      <input textfieldinput="true" label="Identificador" name="id" />
      <input textfieldinput="true" label="Nome" name="quiz_template_kind" />
      <select textfieldinput="true" label="Status" name="status">
        <option value=""></option>
        <option value={constants.questionnaire.ANSWERED_STATUS_NUMBER}>
          {constants.questionnaire.ANSWERED_LABEL}
        </option>
        <option value={constants.questionnaire.AWAITING_RESPONSE_STATUS_NUMBER}>
          {constants.questionnaire.AWAITING_RESPONSE_LABEL}
        </option>
        <option
          value={constants.questionnaire.PARTIALLY_ANSWERED_STATUS_NUMBER}
        >
          {constants.questionnaire.PARTIALLY_ANSWERED_LABEL}
        </option>
      </select>
      <select textfieldinput="true" label="Visível" name="visible">
        <option value=""></option>
        <option value={true}>Visível</option>
        <option value={false}>Invisível</option>
      </select>

      <select
        autocompleteselectinput="true"
        label="Empresa"
        name="companyId"
        loading={isLoadingCompaniesInput}
        onChangeTypeSearch={handleTypeCompaniesInput}
        optionvalues={companiesOptionsValues}
        noOptionsText={instructionsText(companyInputValue)}
      />
      <input textfieldinput="true" label="Nome da empresa" name="company" />
      <input
        textfieldinput="true"
        label="Documento da empresa"
        name="document"
      />
      <select textfieldinput="true" label="Tipo da empresa" name="company_type">
        <option value=""></option>
        <option value="template">Template</option>
        <option value="has_template">
          Gerada a partir de empresa template
        </option>
        <option value="no_template">Não template</option>
      </select>
    </Filters>
  )
}

export default QuestionnaireFilter
